export default {
	default: [''],
	leftLabel: ['textarea--left-label']
};
